import { Chameleon } from '@/lib/Chameleon';
import { Pendo } from '@/lib/Pendo';
import { Userpilot } from '@/lib/Userpilot';
import { UserModel } from '@/models/UserModel';

export const identifyProductTours = (user: UserModel): void => {
  Pendo.identify(user);
  Chameleon.identify(user);
  Userpilot.identify(user);
};
